<template>
    <div
        class="text-button"
        :class="{ 'text-button--inline': inline }"
        @click="$emit('click')"
    >
        {{ $slots.default[0].text }}
    </div>
</template>

<script>
export default {
    props: {
        inline: {
            type: Boolean,
            default: false,
        },
    },
};
</script>

<style lang="less">
.text-button {
    /* font-weight: 500; */
    font-size: 14px;
    line-height: 20px;
    color: #0067ed;
    cursor: pointer;
    transition: color 0.25s;
    &--inline {
        display: inline-block;
    }
    &:hover {
        color: #197dff;
    }
}
</style>
